import styled from 'styled-components';

export const BannerContainer = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 10px;

    width: 100%;
    background-color: yellow;
    background-image: linear-gradient(-159deg, #41464d 0%, #16171b 100%);
    padding: 15px;
`;

export const CloseButton = styled.div`
    width: 25px;
    height: 25px;
    opacity: 0.2;

    color: #ffffff;
    text-align: center;
    line-height: 25px;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.4;
`;

export const StrongText = styled.strong`
    color: rgba(255, 255, 255, 0.75);
    font-size: 18px;
    margin-right: 5px;
`;

export const Header = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const Body = styled.div`
    padding: 0 25px 0 15px;

    & > p:first-of-type {
        color: rgba(255, 255, 255, 0.75);
        font-size: 18px;
        font-weight: 300;
        line-height: 1.4;
    }
`;

export const LinkToFreeTrail = styled.div`
    padding: 5px 10px;
    color: #ffffff;
    background-color: rgba(255, 2555, 255, 0.2);
    border-radius: 3px;
    margin-top: 10px;
    display: block;
    float: left;
    font-size: 12px;
    font-weight: bold;

    &:before {
        content: '';
        clear: both;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Banner/style.js